"use strict";

/**
 *
 * Prepares and handles the audio uploader element.
 *
 */

require("jquery-confirm");
require("jquery-confirm/dist/jquery-confirm.min.css");

const axios = require("axios");
const $ = require("jquery");
const formStatus = require("./../booking-form-status/booking-form-status");

// returns the upload url for an audio file.
function getUploadUrl(identifier, baseRoute) {
  return baseRoute + "?identifier=" + identifier + "&type=audio";
}

// returns the update url for an audio file.
function getUpdateUrl(id, baseRoute) {
  return baseRoute + "/" + id;
}

// returns the delete url for an audio file.
function getDeleteUrl(id, baseRoute) {
  return baseRoute + "/" + id;
}

// Add or remove the link element from the audio upload.
function updateTheAudioLink(audioUploader, url, description = "") {
  if (url) {
    let link = "";
    link =
      '<a href="' +
      url +
      "?preview=" +
      Date.now() +
      '" target="_blank" class="link--green">';
    link += description;
    link += "</a>";

    $(audioUploader)
      .find(".js-audio-uploader-link")
      .html(link);
  } else {
    $("js-audio-uploader-link").html("");
  }
}

//  callback when the upload is successful.
function onUploadSuccess(audioUploader, data, msg) {
  $(".js-audio-upload-submit").removeClass("button--orange");
  $(audioUploader)
    .find(".js-audio-uploader-description")
    .removeClass("is-invalid");
  $(audioUploader)
    .find(".js-audio-uploader--error")
    .empty();

  const url = data.mediaItem.url;
  const description = data.mediaItem.description
    ? data.mediaItem.description
    : data.mediaItem.value; // @todo why setting the value of the "value" attribute as description??

  updateTheAudioLink(audioUploader, url, description);
  $(audioUploader)
    .find(".js-audio-uploader-description")
    .val(description);
  $(audioUploader)
    .find("form")
    .attr("data-id", data.mediaItem.id);
  $(audioUploader).addClass("audio-uploader--has-file");
  $(audioUploader).removeClass("audio-uploader--has-changed");
  const message = data ? data.success : msg;
  formStatus.showSuccess("js-audio-upload-section-form-status", message);
}

//  callback when the upload has error.
function onUploadError(audioUploader, msg) {
  formStatus.showError("js-audio-upload-section-form-status", msg);
  $(audioUploader).removeClass("audio-uploader--loading");
  $(audioUploader)
    .find(".js-audio-uploader-description")
    .addClass("is-invalid");
  $(audioUploader)
    .find(".js-audio-uploader--error")
    .empty()
    .append(msg);
  updateTheAudioLink(audioUploader, null);
}

//  callback when the delete is successful.
function onDeleteSuccess(audioUploader, data, msg) {
  $(".js-audio-upload-submit").removeClass("button--orange");
  $(audioUploader).removeClass("audio-uploader--has-file");
  $(audioUploader)
    .find("form")
    .attr("data-id", "null");
  $(audioUploader)
    .find(".js-audio-uploader-description")
    .val("");
  $(audioUploader)
    .find(".js-audio-uploader-link")
    .html("");
  updateTheAudioLink(audioUploader, null);

  const message = data ? data.success : msg;
  formStatus.showSuccess("js-audio-upload-section-form-status", message);
}

function onDeleteError(msg) {
  formStatus.showError("js-audio-upload-section-form-status", msg);
}

//  Makes the actual call to the backend
function makeRequest(url, formData, method, audioUploader) {
  const headers = {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    cache: false
  };
  formData.append("_method", method);

  axios
    .post(url, formData, headers)
    .then(function(result) {
      if (method == "DELETE") {
        onDeleteSuccess(audioUploader, result.data);
      } else {
        onUploadSuccess(audioUploader, result.data);
      }

      $(audioUploader).removeClass("audio-uploader--loading");
      $(audioUploader).removeClass("audio-uploader--has-changed");
    })
    .catch(function(err) {
      let errorMessage;
      try {
        for (let attribute in err.response.data.errors) {
          let errorsForAttribute = err.response.data.errors[attribute];
          errorMessage = errorsForAttribute[0];
        }
      } catch (e) {
        errorMessage = err.response.data.message;
      }
      if (method == "DELETE") {
        onDeleteError(errorMessage);
      } else {
        onUploadError(audioUploader, errorMessage);
      }

      $(audioUploader).removeClass("audio-uploader--loading");
    });
}

function deleteItem(audioUploader) {
  $.confirm({
    title: "Löschen bestätigen",
    content: "Willst du die Medien Datei wirklich löschen?",
    draggable: false,
    backgroundDismiss: true,
    buttons: {
      cancel: {
        text: "Abbrechen",
        action: function() {}
      },
      confirm: {
        text: "Löschen",
        btnClass: "button button--orange",
        action: function() {
          formStatus.clearStatus("js-audio-upload-section-form-status");
          $(audioUploader).addClass("audio-uploader--loading");
          const form = $(audioUploader).find("form");
          const formData = new FormData(form.get(0));
          const method = "DELETE";
          const id = $(form).attr("data-id");
          formData.append("_method", "DELETE");
          const baseRoute = $(form).attr("data-base-route");
          const url = getDeleteUrl(id, baseRoute);
          makeRequest(url, formData, method, audioUploader);
        }
      }
    }
  });
}

// callback. called when the file is loaded locally.
function onFileLoad(_, element, audioUploader) {
  const file = element.files[0];
  $(audioUploader).addClass("audio-uploader--has-changed");
  $(".js-audio-upload-submit").addClass("button--orange");
  $(".js-audio-upload-submit").attr("disabled", false);
  $(".js-profile-media-submit").addClass("button--orange");

  $(audioUploader)
    .find(".js-audio-uploader-link")
    .html("<span class='video-uploader__link'> " + file.name + " </span>");

  $(audioUploader)
    .find(".js-audio-uploader-description")
    .focus();

  // NOTE: uncomment the next line to allow imediate upload.
  // uploadAudioFiles();
}

// upload the audio files.
function uploadAudioFiles() {
  $(".audio-uploader--has-changed").each(function(i, audioUploader) {
    uploadSingleFile(audioUploader);
  });
}

/**
 *
 * Uploads a single file.
 *
 * @param {object} audioUploader The html element of the uploader
 */
function uploadSingleFile(audioUploader) {
  formStatus.clearStatus("js-audio-upload-section-form-status");
  $(audioUploader).addClass("audio-uploader--loading");
  const form = $(audioUploader)
    .find("form")
    .get(0);
  const formData = new FormData(form);

  $(audioUploader)
    .find(".js-audio-uploader-link")
    .html("");
  const id = $(form).attr("data-id");
  const identifier = $(form).attr("data-identifier");
  const baseRoute = $(form).attr("data-base-route");

  const url =
    id == "null"
      ? getUploadUrl(identifier, baseRoute)
      : getUpdateUrl(id, baseRoute);
  const method = id == "null" ? "POST" : "PUT";
  const description = $(audioUploader)
    .find(".js-audio-uploader-description")
    .val();

  if (
    method == "PUT" &&
    $(audioUploader)
      .find("input[type=file]")
      .get(0).files.length === 0
  ) {
    formData.delete("value");
  }

  formData.append("description", description);
  makeRequest(url, formData, method, audioUploader);
}

function onLoad(consentControl) {
  $(".js-audio-uploader").each(function(_, element) {
    $(element)
      .find("js-audio-uploader-button")
      .on("click", function(_) {
        formStatus.clearStatus("js-audio-upload-section-form-status");
      });

    const el = $(element).find("input[type=file]");
    $(el).on("change", function(e) {
      onFileLoad(e, this, element);
    });

    $(element)
      .find(".js-audio-uploader-description")
      .on("input keydown paste", function() {
        $(element).addClass("audio-uploader--has-changed");
        $(".js-audio-upload-submit").addClass("button--orange");
        $(".js-audio-upload-submit").attr("disabled", false);
        $(".js-profile-media-submit").addClass("button--orange");
      });

    $(element)
      .find(".js-audio-uploader-delete")
      .on("click", function() {
        deleteItem(element);
      });

    $(element)
      .find("form")
      .on("keyup keypress", function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
          e.preventDefault();
          return false;
        }
      });
  });

  $(".js-audio-upload-submit").on("click", function() {
    consentControl(function() {
      uploadAudioFiles();
    });
  });
}

module.exports = {
  onLoad,
  uploadAudioFiles
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-audio-uploader/booking-audio-uploader.js